module.exports = __webpack_public_path__ + "img/wuhan.5235bfc4.png";